// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson
// 3-2-1-GO between the host's start arriving and the first turn (principle #15).
// The audio carries it — players watch the table, not the overlay.
import type { Sfx } from '@ben-gy/game-engine/sound';

export interface Countdown {
  cancel(): void;
}

export function createCountdown(o: {
  root: HTMLElement;
  sfx: Sfx;
  from?: number;
  reducedMotion?: boolean;
  onDone: () => void;
}): Countdown {
  let n = o.from ?? 3;
  let timer: ReturnType<typeof setTimeout> | undefined;
  let done = false;

  const el = document.createElement('div');
  el.className = 'countdown';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'assertive');
  if (o.reducedMotion) el.classList.add('reduced');
  o.root.appendChild(el);

  const paint = (text: string, cls: string): void => {
    el.innerHTML = `<span class="cd-num ${cls}">${text}</span>`;
  };

  const finish = (): void => {
    if (done) return;
    done = true;
    if (timer) clearTimeout(timer);
    el.remove();
  };

  const step = (): void => {
    if (done) return;
    if (n > 0) {
      paint(String(n), 'cd-tick');
      o.sfx.play('beat', { pitch: 1 + (3 - n) * 0.12 });
      n--;
      timer = setTimeout(step, 800);
      return;
    }
    paint('GO', 'cd-go');
    o.sfx.play('go');
    timer = setTimeout(() => {
      finish();
      o.onDone();
    }, 420);
  };

  step();
  return { cancel: finish };
}
